<div class="dialog-wrappers add-question-dialog">
  <div class="display-flex padding-dialog dialog-header">
  <div class="float-left">
    <div class="dialog-header-title">        
      <h1>{{ isEditMode ? 'Edit Question' : 'Add Question' }}</h1>
    </div>      
  </div>
  <div class="float-right">
    <span class="close-dialog" (click)="cancel()"><img src="../../../assets/icons/icon-close.png" alt="Close" width="16" /></span>
     
    </div>
  </div>
  <mat-dialog-content>
  <div class="padding-dialog">
    <textarea class="area" placeholder="Type a question here to add" [(ngModel)]="faqQuestion"></textarea>
  </div>
  </mat-dialog-content>
  
  <mat-dialog-actions class="dialog-actions">
    <button (click)="cancel()" class="btn-white btn-dialog-cancel">Cancel</button>
    <button (click)="submit()" class="btn-red">{{ isEditMode ? 'Update' : 'Add' }}</button>
  </mat-dialog-actions>
</div>
